/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakOutcome } from './StreakOutcome';
import {
    StreakOutcomeFromJSON,
    StreakOutcomeFromJSONTyped,
    StreakOutcomeToJSON,
    StreakOutcomeToJSONTyped,
} from './StreakOutcome';

/**
 * Outcome configuration triggered at a specific streak count
 * @export
 * @interface StreakMilestone
 */
export interface StreakMilestone {
    /**
     * The streak length at which this milestone triggers
     * @type {number}
     * @memberof StreakMilestone
     */
    streakCount: number;
    /**
     * 
     * @type {Array<StreakOutcome>}
     * @memberof StreakMilestone
     */
    outcomes: Array<StreakOutcome>;
    /**
     * Whether this milestone fires every N windows
     * @type {boolean}
     * @memberof StreakMilestone
     */
    isRepeating?: boolean;
    /**
     * N for repeating milestones (fires at streakCount, streakCount+N, streakCount+2N, ...)
     * @type {number}
     * @memberof StreakMilestone
     */
    repeatInterval?: number;
}

/**
 * Check if a given object implements the StreakMilestone interface.
 */
export function instanceOfStreakMilestone(value: object): value is StreakMilestone {
    if (!('streakCount' in value) || value['streakCount'] === undefined) return false;
    if (!('outcomes' in value) || value['outcomes'] === undefined) return false;
    return true;
}

export function StreakMilestoneFromJSON(json: any): StreakMilestone {
    return StreakMilestoneFromJSONTyped(json, false);
}

export function StreakMilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakMilestone {
    if (json == null) {
        return json;
    }
    return {
        
        'streakCount': json['streakCount'],
        'outcomes': ((json['outcomes'] as Array<any>).map(StreakOutcomeFromJSON)),
        'isRepeating': json['isRepeating'] == null ? undefined : json['isRepeating'],
        'repeatInterval': json['repeatInterval'] == null ? undefined : json['repeatInterval'],
    };
}

export function StreakMilestoneToJSON(json: any): StreakMilestone {
    return StreakMilestoneToJSONTyped(json, false);
}

export function StreakMilestoneToJSONTyped(value?: StreakMilestone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'streakCount': value['streakCount'],
        'outcomes': ((value['outcomes'] as Array<any>).map(StreakOutcomeToJSON)),
        'isRepeating': value['isRepeating'],
        'repeatInterval': value['repeatInterval'],
    };
}

